import { combineReducers } from 'redux';
import { orders } from './orders';
import { filters } from './filters';
import { orderCard } from './orderCard';
import { mail } from './mail';

export const Orders = combineReducers({
  filters,
  orders,
  orderCard,
  mail,
});
